import { put, race, select, take } from 'redux-saga/effects';
import { pick } from 'lodash';
import {
  actionTypes,
  startRequest as getAvailableYears,
} from 'modules/Taps/redux/availableYears/actions';
import {
  getParentDeclarationByYear,
  getParentDeclarationByYearSuccess,
  starStepFetching,
  stopStepFetching,
} from 'modules/Taps/components/NDFL3Light/redux/actions';
import {
  GET_PARENT_DECLARATION_BY_YEAR_ERROR,
  GET_PARENT_DECLARATION_BY_YEAR_SUCCESS,
} from 'modules/Taps/components/NDFL3Light/redux/actionTypes';
import {
  selectDraft,
  selectDraftMode,
  selectYear,
} from 'modules/Taps/components/NDFL3Light/selectors';

/**
 * Initial data step worker
 * @returns {IterableIterator<*>}
 */
export default function* initialDataSaga() {
  const state = yield select();
  const reportMode = selectDraftMode(state);
  const reportYear = selectYear(state);
  const draft = selectDraft(state);

  yield put(starStepFetching());
  yield put(getAvailableYears(reportMode));
  yield take(actionTypes.REQUEST_SUCCESS);

  if (draft) {
    const isFirstSubmit = draft && draft.getIn(['payload', 'initialData', 'firstSubmit']);
    const result = isFirstSubmit ? null : draft.getIn(['payload', 'originalData']).toJSON();

    if (result) {
      result.totals = pick(result, ['toPayTP', 'toRefundTP', 'incomeTotal']);
    }

    yield put(getParentDeclarationByYearSuccess(result));
    return yield put(stopStepFetching());
  }

  if (reportYear) {
    yield put(getParentDeclarationByYear(reportYear));
    yield race({
      success: take(GET_PARENT_DECLARATION_BY_YEAR_SUCCESS),
      failure: take(GET_PARENT_DECLARATION_BY_YEAR_ERROR),
    });
  }

  yield put(stopStepFetching());
}
